function initSortDropdown() {
  const select = document.querySelector('.facetwp-facet-sort_by select');
  if (!select) return;

  const facetDiv = select.closest('.facetwp-facet');
  if (!facetDiv) return;

  // Remove any previous custom dropdown
  const existing = facetDiv.parentNode.querySelector('.fs-wrap');
  if (existing) existing.remove();

  // Build custom dropdown
  const fsWrap = document.createElement('div');
  fsWrap.className = 'fs-wrap';

  const labelWrap = document.createElement('div');
  labelWrap.className = 'fs-label-wrap';

  const label = document.createElement('span');
  label.className = 'fs-label';
  label.textContent = select.options[select.selectedIndex]?.text || 'Sort By';

  const arrow = document.createElement('span');
  arrow.className = 'fs-arrow';

  labelWrap.appendChild(label);
  labelWrap.appendChild(arrow);

  const dropdown = document.createElement('div');
  dropdown.className = 'fs-dropdown';

  const optsList = document.createElement('div');
  optsList.className = 'fs-options';

  Array.from(select.options).forEach((opt) => {
    const item = document.createElement('div');
    item.className = 'fs-option' + (opt.selected ? ' selected' : '');
    item.dataset.value = opt.value;
    item.textContent = opt.text;

    item.addEventListener('click', () => {
      label.textContent = opt.text;
      optsList.querySelectorAll('.fs-option').forEach(o => o.classList.remove('selected'));
      item.classList.add('selected');
      fsWrap.classList.remove('fs-open');

      if (typeof FWP !== 'undefined') {
        FWP.extras.sort = opt.value;
        FWP.fetchData();
      }
    });

    optsList.appendChild(item);
  });

  dropdown.appendChild(optsList);
  fsWrap.appendChild(labelWrap);
  fsWrap.appendChild(dropdown);

  labelWrap.addEventListener('click', (e) => {
    e.stopPropagation();
    fsWrap.classList.toggle('fs-open');
  });

  document.addEventListener('click', () => {
    fsWrap.classList.remove('fs-open');
  });

  facetDiv.style.display = 'none';
  facetDiv.parentNode.insertBefore(fsWrap, facetDiv);
}

$(document).on('facetwp-loaded', initSortDropdown);
